import authAxios from "../common/authAxios";

class EpvoService {
    async syncWithEpvo() {
        return await authAxios.get('/secretary/convert-abitur-to-epvo-student');
    }

    async sendToEpvo(userId) {
        return await authAxios.post(`/admission-info/send-to-epvo?userId=${userId}`);
    }
}

export default EpvoService;